module.exports = __webpack_public_path__ + "img/pr-20.7beea6ea.png";